import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  /* SESSION STORAGE SET ITEM */
  setSessionStorageItem(key: string, value: string): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem(key, value);
    } else {
      return null;
    }
  }

  /* SESSION STORAGE GET ITEM */
  getSessionStorageItem(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      switch (key) {
        case 'currency':
          return this.catchNullCurrency(key);
        default:
          return sessionStorage.getItem(key);
      }
    } else {
      return null;
    }
  }

  /* LOCAL STORAGE SET ITEM */
  setLocalStorageitem(key: string, value: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, value);
    } else {
      return null;
    }
  }

  /* LOCAL STORAGE GET ITEM */
  getLocalStorageItem(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(key);
    } else {
      return null;
    }
  }

  /* SESSION STORAGE REMOVE ITEM */
  removeSessionStorageItem(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.removeItem(key);
    } else {
      return null;
    }
  }

  /* SESSION STORAGE REMOVE ITEM */
  removeLocalStorageItem(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(key);
    } else {
      return null;
    }
  }

  /* SESSION STORAGE CLEAR ITEM */
  clearSessionStorageItem(): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.clear();
    } else {
      return null;
    }
  }

  /* LOCAL STORAGE CLEAR ITEM */
  clearLocalStorageItem(): void {
    if (isPlatformBrowser(this.platformId)) {
      const storedItemsToRetain = this.getLocalStorageItemsToRetain();
      localStorage.clear();
      this.setMultipleLocalStorageItems(storedItemsToRetain);
    } else {
      return null;
    }
  }

  /* LOCAL STORAGE SET MULTIPLE ITEMS */
  setMultipleLocalStorageItems(items: { [key: string]: string }): void {
    Object.keys(items).forEach((key) => {
      this.setLocalStorageitem(key, items[key]);
    });
  }

  getLocalStorageItemsToRetain(): { [key: string]: string } {
    const keysToRetain = ['plpView']; // add more keys here
    const items: any = {};
    keysToRetain.forEach((key) => {
      const value = this.getLocalStorageItem(key);
      if (value) {
        items[key] = value;
      }
    });
    return items;
  }

  /* RETURN 'USD' WHEN NULL */
  catchNullCurrency(key: string): string {
    return sessionStorage.getItem(key) ?? 'USD';
  }
}
